module.exports = __webpack_public_path__ + "static/moderni-technologie-pro-retail-audit-af9098dc1f68db876d2914388be9555f.jpg";